import { render, staticRenderFns } from "./brandMaintenance.vue?vue&type=template&id=23ba231b&scoped=true&"
import script from "./brandMaintenance.vue?vue&type=script&lang=js&"
export * from "./brandMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba231b",
  null
  
)

export default component.exports